export const roundToPrecision = (v: number, precision = 0) => {
  const factor = Math.pow(10, precision);
  return Math.round((v + Number.EPSILON) * factor) / factor;
}